interface CardButtonProps {
  title: string;
  description: string;
  logo: string;
  link: string;
}

const CardButton: React.FC<CardButtonProps> = ({ title, description, logo, link }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center p-3 border-2 border-utdGreen rounded-lg hover:shadow-lg transition-shadow bg-white min-w-[250px] hover:shadow-lg hover:bg-utdOrange/10 hover:border-utdOrange transition-all">
      {/* Logo */}
      {logo && (
        <span
          className="material-symbols-outlined text-orange-500 text-5xl mr-4"
          style={{ fontVariationSettings: "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 48" }}
        >
          {logo}
        </span>
      )}

      {/* Text Content */}
      <div>
        <h3 className="text-lg font-bold text-utdGreen">{title}</h3>
        <p className="text-sm text-utdGreen">{description}</p>
      </div>
    </a>
  );
};

export default CardButton;
